<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chifarrer0006#pref">Preface</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0007#ch01">1 Scenes and Nightscapes</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0008#ch02">2 The Golden Age of the Jazz Cabaret</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0009#ch03">3 The Fall and Rise of Social Dance</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0010#ch04">4 Transnational Club Cultures</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0011#ch05">5 Imbibing Cosmopolitanism</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0012#ch06">6 Jazz Metropolis</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0013#ch07">7 Nightlife Sexual Scenes</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0014#ch08">8 From Interzones to Transzones</a></p>
<p class="toc"><a class="xref" href="#/chifarrer0015#ch09">9 Nightlife Neighborhoods</a></p>
<p class="tocbm"><a class="xref" href="#/chifarrer0016#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chifarrer0017#index">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-farrer-0005.vue?11fde0ac